"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListGlobalItemHelper = void 0;
const sitemate_global_shared_1 = require("@site-mate/sitemate-global-shared");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const style_variants_enum_1 = require("../fields/style-variants.enum");
const global_item_models_1 = require("../global-items/global-item-models");
const item_states_enum_1 = require("../global-items/item-states.enum");
class ListGlobalItemHelper {
    static createList({ name, parentId, properties = [], defaultStyle = style_variants_enum_1.StyleVariants.Sky, legacyId, deployedParents = [], }) {
        return __awaiter(this, void 0, void 0, function* () {
            const itemId = yield sitemate_global_shared_1.Flake.generate(sitemate_global_shared_1.Flake.prefixes.List);
            const now = new Date();
            return {
                _id: `${parentId}/${itemId}`,
                model: global_item_models_1.GlobalItemModels.Container,
                state: item_states_enum_1.ItemStates.Active,
                data: {
                    name,
                    defaultStyle,
                    properties,
                },
                metadata: Object.assign(Object.assign({}, (legacyId && { legacyId })), { deployedParents, createdAt: now, updatedAt: now, itemId }),
            };
        });
    }
    static createRow({ listId, value, legacyId, rowIndex = 0, rowStyle = style_variants_enum_1.StyleVariants.None, deployedParents = [], }) {
        return __awaiter(this, void 0, void 0, function* () {
            const itemId = yield sitemate_global_shared_1.Flake.generate(sitemate_global_shared_1.Flake.prefixes.ListRow);
            const now = new Date();
            return {
                _id: `${listId}/${itemId}`,
                data: {
                    value,
                    style: rowStyle,
                },
                metadata: Object.assign(Object.assign({}, (legacyId && { legacyId })), { deployedParents, position: rowIndex, createdAt: now, updatedAt: now, itemId }),
                model: global_item_models_1.GlobalItemModels.TextSimple,
                state: item_states_enum_1.ItemStates.Active,
            };
        });
    }
    static createCell(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { rowId, propertyId, value, attachments = [], model, timezone } = params;
            const itemId = yield sitemate_global_shared_1.Flake.generate(sitemate_global_shared_1.Flake.prefixes.ListCell);
            const now = new Date();
            const cellValue = model === global_item_models_1.GlobalItemModels.AttachmentSimple ? { attachments } : { value };
            return {
                _id: `${rowId}/${propertyId}/${itemId}`,
                data: ListGlobalItemHelper.getListCellValue(cellValue, model, timezone),
                metadata: { itemId, createdAt: now, updatedAt: now },
                model,
                state: item_states_enum_1.ItemStates.Active,
            };
        });
    }
    static getListCellValue(value, model, timezone) {
        const dataGetterMap = {
            [global_item_models_1.GlobalItemModels.TextSimple]: ListGlobalItemHelper.getGenericData,
            [global_item_models_1.GlobalItemModels.DateSimple]: ListGlobalItemHelper.getDateData,
            [global_item_models_1.GlobalItemModels.DateExpiry]: ListGlobalItemHelper.getDateData,
            [global_item_models_1.GlobalItemModels.NumberSimple]: ListGlobalItemHelper.getNumberData,
            [global_item_models_1.GlobalItemModels.AttachmentSimple]: ListGlobalItemHelper.getAttachmentData,
        };
        return dataGetterMap[model](value, timezone);
    }
    static getGenericData({ value = '' }) {
        return { value };
    }
    static getNumberData({ value }) {
        const number = Number(value);
        if (value === '') {
            return { value: null };
        }
        if (value === null || value === undefined || Number.isNaN(number)) {
            throw new Error('Number value is required.');
        }
        return { value: number };
    }
    static getDateData({ value }, timezone = 'UTC') {
        const errorMessage = 'Invalid date format.';
        const formats = ['YYYY-MM-DDTHH:mm:ss.SSSZ', 'DD/MM/YYYY', 'D/MM/YYYY', 'DD/M/YYYY', 'D/M/YYYY'];
        if (value === '') {
            return { value: null };
        }
        if (value === null || value === undefined) {
            throw new Error(errorMessage);
        }
        if (value instanceof Date) {
            return { value };
        }
        const date = moment_timezone_1.default.tz(value, formats, timezone);
        if (!date.isValid()) {
            throw new Error(errorMessage);
        }
        return { value: date.toDate() };
    }
    static getAttachmentData({ attachments = [] }) {
        return { attachments };
    }
}
exports.ListGlobalItemHelper = ListGlobalItemHelper;
